export default "__VITE_ASSET__D20$OUdC__"